import { useRouteError, Link } from "react-router-dom";

const Error = () => {
    const err = useRouteError();
    return (
        <div className="error-page">
            <h1>Oops!</h1>
            <h2>Something went wrong.</h2>
            {err && (
                <h3>
                    {err.status} {err.statusText}
                </h3>
            )}
            <Link to="/" className="btn btn-primary">Back to Home</Link>
        </div>
    )
}

export default Error;